import { render, staticRenderFns } from "./VehicleSummary.vue?vue&type=template&id=37031106"
import script from "./VehicleSummary.vue?vue&type=script&lang=ts"
export * from "./VehicleSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports